import { Fragment, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, Col, Row, Spinner } from "reactstrap";
import * as Yup from "yup";
import { Stepper } from 'react-form-stepper';
import Error from "../../../../components/messagesModal/error";

import Validation from "../../../../utils/validation";
import { formatCurrency } from "../../../../utils/converts";
import { actions as actionsSite } from "../../../../redux/actions/site";
import "../../consultas.scss";
import "./styles.scss";
import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";

const VeicularAtpve = () => {
  new Validation(Yup);
  const profile = useSelector((state) => state.auth.profile);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState(null);
  const [price, setPrice] = useState(null);
  const [valuesStep1, setValuesStep1] = useState({});
  const [valuesStep2, setValuesStep2] = useState({});
  const [currentStep, setCurrentStep] = useState(0);

  const getQuery = useCallback(async () => {
    const code = location.pathname.split("/").pop();
    const query = profile.permissionsQueries.find((q) => q.code === code);
    return query;
  },[location, profile]);

  const getQueryPrice = useCallback(async (query) => {
    const _query = profile.clientPrice.queries.find(price => price.query === query._id);
    return _query.price;
  },[profile]);

  useEffect(() => {
    const run = async () => {
      const _query = await getQuery();

      if (_query) {
        const _price = await getQueryPrice(_query);
        setQuery(_query);
        setPrice(_price);
        setLoading(false);
      } else {
        const configModal = {
          component: <Error msg={"Consulta não encontrada"} />,
          title: `Erro`,
        };
        dispatch(actionsSite.setModal(configModal));
        history.push("/dashboard");
        setLoading(false);
      }
    };

    run();
  }, [location, history, getQueryPrice, getQuery, dispatch]);

  const steps = [
    {
      title: 'Dados do Veículo / Proprietário',
      label: <Fragment>Dados do Veículo <i className="fa-solid fa-car"></i> / Proprietário <i className="fa-solid fa-user"></i> </Fragment>,
      onClick: () => setCurrentStep(0)
    },

    {
      title: 'Dados do Comprador',
      label: <Fragment>Dados do Comprador <i className="fa-solid fa-clipboard-list"></i></Fragment>,
      onClick: () => setCurrentStep(1)
    },
    {
      title: 'Enviar Transferência',
      label: <Fragment>Enviar Transferência <i className="fa-solid fa-clipboard-check"></i></Fragment>,
      onClick: () => setCurrentStep(2)
    },
  ];

  const getActiveStep = () => {
    switch(currentStep) {
      case 0: return <Step1 values={valuesStep1} setValues={setValuesStep1} setCurrentStep={setCurrentStep} />;
      case 1: return <Step2 values={valuesStep2} setValues={setValuesStep2} setCurrentStep={setCurrentStep} />;
      case 2: return <Step3 query={query} values={{...valuesStep1, ...valuesStep2}} setCurrentStep={setCurrentStep} />;
      default: return null;
    }
  }

  return (
    <Card>
      <CardBody>
        {loading ? (
          <div className="text-center">
            <Spinner color="danger" />
          </div>
        ) : (
          <form onSubmit={(event) => { event.preventDefault() }}>
            <Row>
              <Col xs="12">
                <CardTitle>
                  <i className={`${query.icon} mr-1`}></i>
                  {query.isBlocked ?
                  <>
                    <del className="mr-2">
                      {query.type} - {query.name}
                    </del>
                    <span className="text-danger">
                      - EM MANUTENÇÃO
                    </span>
                  </>
                  :
                    query.type + ' - ' + query.name + (profile.client.showPrice ? ` | R$ ${formatCurrency(price)}` : '')
                  }
                </CardTitle>
                <div dangerouslySetInnerHTML={{ __html: query.description }} className="mb-3"/>
              </Col>
            </Row>
            <Stepper
              steps={steps}
              activeStep={currentStep}
              connectorStateColors={true}
              connectorStyleConfig={{
                completedColor: '#2b7cff',
                activeColor: '#2b7cff',
                disabledColor: '#000'
              }}
              styleConfig={{
                activeBgColor: '#2b7cff',
                activeTextColor: '#fff',
                inactiveBgColor: '#fff',
                inactiveTextColor: '#000',
                completedBgColor: '#28a745',
                completedTextColor: '#fff',
                size: '3em'
              }}
            >
            </Stepper>
            <Row>
              <Col md="4" className="offset-md-8">
                <Card className="border-danger">
                  <CardHeader>
                    <h4>
                      <span className="text-danger">***</span> = Campos Obrigatórios
                    </h4>
                  </CardHeader>
                </Card>
              </Col>
            </Row>
            {getActiveStep()}
          </form>
        )}
      </CardBody>
    </Card>
  );
};

export default VeicularAtpve;
